import { createApp } from 'vue'
import { getUrlWithQueryParams } from '~/js/helpers/url-helper'

const CLASS_NAME_PRODUCT_REVIEW = 'js-sections-product-review'
const ID_ZVLIST = 'ZVList'
const ID_ZETA_REVIEW_COUNT = 'zv-n-reviews'

const getReviewCount = () => {
  const elementReviewCount = document.getElementById(ID_ZETA_REVIEW_COUNT)
  if (!elementReviewCount) return

  // elementReviewCount.innerText の例
  // \n11件のレビューがヒットしました。全てのレビューを表示
  const match = elementReviewCount.innerText.match(/\d+/)
  if (!match) return

  return Number(match[0])
}

document.addEventListener('DOMContentLoaded', () => {
  const elementsProductReview = document.getElementsByClassName(
    CLASS_NAME_PRODUCT_REVIEW
  )
  if (!elementsProductReview.length) return

  Array.from(elementsProductReview).forEach((element) => {
    const elementZVList = element.querySelector(`#${ID_ZVLIST}`)
    if (!elementZVList) return

    const { reviewSets } = element.dataset
    const items = (reviewSets || '').split(',').map((reviewSet) => {
      const [label, questionnaireSlug] = reviewSet.split(':')
      return { label, questionnaireSlug }
    })

    createApp({
      name: 'SectionsProductReview',
      data() {
        return {
          items,
          reviewCount: getReviewCount(),
          selectedIndex: 0,
        }
      },
      computed: {
        hrefReview() {
          return getUrlWithQueryParams({
            view: 'review',
            slug: this.items[this.selectedIndex].questionnaireSlug,
          })
        },
        questionnaireSlug() {
          return this.items[this.selectedIndex].questionnaireSlug
        },
      },
      mounted() {
        document.addEventListener('zvrendercomplete', this.onReviewChanged)
      },
      beforeUnmount() {
        document.removeEventListener('zvrendercomplete', this.onReviewChanged)
      },
      methods: {
        onReviewChanged() {
          this.reviewCount = getReviewCount()
        },
        changeReview(index) {
          this.selectedIndex = index
          element.querySelector(`#${ID_ZVLIST}`).innerHTML = ''
          this.$nextTick(() => {
            window.zvRenderReviewList()
          })
        },
        moveToLogin() {
          window.dispatchEvent(
            new CustomEvent('button-login-required-clicked', {
              detail: { text: 'レビューを投稿するには<br>' },
            })
          )
        },
      },
    }).mount(element)
  })
})
